import { PlusOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useSupporterAdd } from "hook/supporters/useSupporter";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultSupporterInfoSelector } from "store/user/(default)/supporter/default_supporter.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterAction = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const { loading, handleAdd } = useSupporterAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const supporterInfo = useSelector(defaultSupporterInfoSelector);
  // -------------------------- FUNCTION ------------------------
  const handleAddSupporter = () => {
    return handleAdd(form);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!supporterInfo) return null;
  return (
    <Button
      block
      type="primary"
      style={{ borderRadius: 4 }}
      icon={<PlusOutlined />}
      onClick={handleAddSupporter}
      loading={loading}
      disabled={loading}
    >
      Thêm Nhân Viên
    </Button>
  );
};
export default SupporterAction;
